// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__2jko1","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__1k45L"};